import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "content"];

  connect() {
    this.togglePromptSections();
  }

  togglePromptSections() {
    const selectedValue = this.selectTarget.value;

    this.contentTargets.forEach(section => {
      section.classList.toggle("tw-hidden", section.dataset.promptType !== selectedValue);
    });
  }
}
